<template>
  <div id="mobile-search-tabs" class="mobile-search-tabs" role="tablist" aria-label="Mobiilin hakuvaihtoehdot">
    <button
      :class="`mobile-search-tabs__nav-item ${getTabClass(config.MOBILE_TABS.SEARCH)}`"
      @click="selectTab(config.MOBILE_TABS.SEARCH)"
      :aria-selected="selectedMobileTab === config.MOBILE_TABS.SEARCH"
      role="tab"
      tabindex="0"
      aria-label="Hae myytäviä asuntoja"
    >
      <i class="toggle-icon icon-search"></i>
    </button>
    <button
      :class="`mobile-search-tabs__nav-item ${getTabClass(config.MOBILE_TABS.LIST)}`"
      @click="selectTab(config.MOBILE_TABS.LIST)"
      :aria-selected="selectedMobileTab === config.MOBILE_TABS.LIST"
      role="tab"
      tabindex="0"
      aria-label="Lista myytävistä asunnoista"
    >
      <i class="toggle-icon icon-list"></i>
    </button>
    <button
      :class="`mobile-search-tabs__nav-item ${getTabClass(config.MOBILE_TABS.MAP)}`"
      @click="selectTab(config.MOBILE_TABS.MAP)"
      :aria-selected="selectedMobileTab === config.MOBILE_TABS.MAP"
      role="tab"
      tabindex="0"
      aria-label="Myytävät asunnot kartalla"
    >
      <i class="toggle-icon icon-map"></i>
    </button>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'mobile-search-tabs',
  data: () => ({
    config,
    mapVisible: false,
    selectedMobileTab: config.MOBILE_TABS.LIST,
  }),
  methods: {
    selectTab(tabName) {
      this.selectedMobileTab = tabName;
      this.$bus.$emit('search-selectedMobileTab', tabName);
    },
    getTabClass(tabName) {
      return this.selectedMobileTab === tabName ? 'selected' : '';
    },
  },
  mounted() {
    this.$bus.$on('search-selectedMobileTab', (tabName) => {
      this.selectedMobileTab = tabName;
    });
  },
};
</script>
